<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="400px">
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          <v-icon left>
            fas fa-fw fa-folder-plus
          </v-icon>
          New Folder
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field v-model="form.folder"
                        label="Folder name"
                        autofocus
                        required
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('path')">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Create folder
          </v-btn>
          <v-btn @click.prevent="cancel"
                 text>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {Form} from 'vform';
import teamAssetService from '../../../../../ml/services/teamAssetService';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        folder: '',
      }),
    }
  },
  watch: {},
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      if (this.form.folder) {
        return teamAssetService.createDirectory(this.form, this.path)
            .then(data => {
              this.$toast.success('Folder created.');
              this.$emit('created');
            })
            .catch(err => {
              //this.form.errors.set(err.response.data);
            })
      } else {
        this.form.errors.set({folder: 'Enter the folder name.'})
      }
    },
    cancel() {
      this.$emit('canceled');
    }
  }
}
</script>
